<template>
  <div id="index-exam-imitate-testing" v-loading="loading">
    <!-- 模拟考试界面 -->
    <div class="left">
      <div class="type" v-for="(itemType, indexType) in data" :key="indexType">
        <div class="title">
          {{ transitionNumToText(indexType) }}、{{
            transitionName(itemType.type)
          }}（{{ itemType.item.length }}题 / {{ itemType.typeTotalPoints }}分）
        </div>
        <div class="thumbnail">
          <div
            :class="{
              item: true,
              'is-answer': item.isAnswer,
              'is-active': item.index == tempQuestion.index,
            }"
            v-for="(item, index) in itemType.item"
            :key="index"
            @click="chooseQuestion(item, indexType, index)"
          >
            {{ item.index }}
            <i
              v-if="!item.answer && !item.grade"
              :class="{
                'el-icon-circle-close':
                  item.answer != '' &&
                  item.grade != '' &&
                  item.grade != item.points,
                'el-icon-circle-check':
                  item.answer != '' &&
                  item.grade != '' &&
                  item.grade == item.points,
              }"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <div class="centent">
      <div class="title">
        {{ transitionNumToText(indexType) }}、{{
          transitionName(data[indexType].type)
        }}（{{ data[indexType].item.length }}题 /
        {{ data[indexType].typeTotalPoints }}分）
      </div>
      <div class="question-title">
        {{ tempQuestion.index }}、<span
          v-html="tempQuestion.questionStem"
        ></span>
        <span class="nd"
          >（难度：<i
            :class="{
              'el-icon-star-off': true,
              'el-icon-star-on': tempQuestion.gradeOfDifficulty >= s,
            }"
            v-for="s in 5"
            :key="s"
          ></i
          >）</span
        >
      </div>
      <div class="xx" v-if="data[indexType].type == '0'">
        <!-- 选择题的选项值 -->
        <el-radio-group v-model="tempQuestion.answer" :disabled="isDisable">
          <el-radio
            class="itel"
            :label="qo.title"
            v-for="(qo, iii) in tempQuestion.questionOptions"
            :key="iii"
            @change="changeAnswer"
          >
            <span style="font-weight: bold">{{ qo.title }}、</span>
            <span v-html="qo.value"></span>
          </el-radio>
        </el-radio-group>
      </div>
      <div class="xx" v-if="data[indexType].type == '1'">
        <!-- 选择题的选项值 -->
        <el-checkbox-group v-model="tempQuestion.answer" :disabled="isDisable">
          <el-checkbox
            class="itel"
            :label="qo.title"
            v-for="(qo, iii) in tempQuestion.questionOptions"
            :key="iii"
            @change="changeAnswer"
          >
            <span style="font-weight: bold">{{ qo.title }}、</span
            ><span v-html="qo.value"></span>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="da">
        <div class="ti">【您的答案】:</div>
        <div class="tv" v-if="data[indexType].type == '0'">
          <!-- 单选 -->
          <span :class="{ answer: isDisable }">{{ tempQuestion.answer }}</span>
        </div>
        <div class="tv" v-if="data[indexType].type == '1'">
          <!-- 多选 -->
          <span
            v-for="(item, index) in tempQuestion.answer"
            :key="index"
            :class="{ answer: isDisable }"
            ><span v-if="index > 0">,</span>{{ item }}</span
          >
        </div>
        <div class="tv pd" v-if="data[indexType].type == '2'">
          <!-- 填空 -->
          <div
            :class="{ li: true }"
            v-for="(item, index) in tempQuestion.answer"
            :key="index"
          >
            <div class="title">{{ item.title }}:</div>
            <div
              :class="{ 'li-va': true, ueditor: !isDisable, answer: isDisable }"
              v-html="item.htmlValue"
              @click="editQuestionStem('填空题答案', item.htmlValue, index)"
            ></div>
          </div>
        </div>
        <div class="tv" v-if="data[indexType].type == '3'">
          <!-- 判断 -->
          <el-radio-group
            v-model="tempQuestion.answer"
            :disabled="isDisable"
            class="div-flex-center div-flex-start"
          >
            <el-radio :label="'0'">
              <i class="el-icon-check"></i>
            </el-radio>
            <el-radio :label="'1'">
              <i class="el-icon-close"></i>
            </el-radio>
          </el-radio-group>
        </div>
        <div class="tv pd" v-if="data[indexType].type == '4'">
          <!-- 简答题 -->
          <div class="li">
            <div
              :class="{ 'li-va': true, ueditor: !isDisable, answer: isDisable }"
              v-html="tempQuestion.answer.htmlValue"
              @click="
                editQuestionStem(
                  '简答题答案',
                  tempQuestion.answer.htmlValue,
                  -1
                )
              "
            ></div>
          </div>
        </div>
      </div>

      <div class="da1" v-if="flag == '1'">
        <div class="ti">【标准答案】:</div>
        <div class="tv" v-if="tempQuestion.topicnType == '0'">
          <!-- 单选 -->
          <span>{{ tempQuestion.trueAnswer[0].value }}</span>
        </div>
        <div class="tv" v-if="tempQuestion.topicnType == '1'">
          <!-- 多选 -->
          <span v-for="(item, index) in tempQuestion.trueAnswer" :key="index"
            ><span v-if="index > 0">,</span>{{ item.value }}</span
          >
        </div>
        <div class="tv pd" v-if="tempQuestion.topicnType == '2'">
          <!-- 填空 -->
          <div
            :class="{ li: true }"
            v-for="(item, index) in tempQuestion.trueAnswer"
            :key="index"
          >
            <div class="title">{{ item.title }}:</div>
            <div
              :class="{ 'li-va': true, ueditor: !isDisable, answer: isDisable }"
              v-html="item.htmlValue"
              @click="editQuestionStem('填空题答案', item.htmlValue, index)"
            ></div>
          </div>
        </div>
        <div class="tv" v-if="tempQuestion.topicnType == '3'">
          <!-- 判断 -->
          <el-radio-group
            v-model="tempQuestion.trueAnswer[0].value"
            class="div-flex-center div-flex-start"
          >
            <el-radio :label="'0'">
              <i class="el-icon-check"></i>
            </el-radio>
            <el-radio :label="'1'">
              <i class="el-icon-close"></i>
            </el-radio>
          </el-radio-group>
        </div>
        <div class="tv pd" v-if="tempQuestion.topicnType == '4'">
          <!-- 简答题 -->
          <div class="li">
            <div
              :class="{ 'li-va': true, ueditor: true, answer: false }"
              v-html="tempQuestion.trueAnswer[0].htmlValue"
              @click="
                editQuestionStem(
                  '简答题答案',
                  tempQuestion.trueAnswer[0].htmlValue,
                  -1
                )
              "
            ></div>
          </div>
        </div>
      </div>
      <div class="perch-active"></div>
      <div class="buts">
        <div class="but" @click="submitExam" v-if="!isDisable">交卷</div>
        <div class="but" @click="chooseQuestionBut(0)">上一题</div>
        <div class="but" @click="chooseQuestionBut(1)">下一题</div>
        <div class="start">
          <div v-if="!tempQuestion.isCollect">
            <el-tooltip
              class="item"
              effect="dark"
              content="收藏"
              placement="top"
            >
              <i class="iconfont icon-shoucang" @click="changeCollect(0)"></i>
            </el-tooltip>
          </div>
          <div v-if="tempQuestion.isCollect">
            <el-tooltip
              class="item"
              effect="dark"
              content="已收藏"
              placement="top"
            >
              <i class="iconfont icon-shoucang1" @click="changeCollect(1)"></i>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="icon">
        <img :src="userData.icon" alt="" />
      </div>
      <div class="line">
        <div class="title">考试主题:</div>
        <div class="value">{{ testName }}</div>
      </div>
      <div class="line">
        <div class="title">姓名:</div>
        <div class="value">{{ userData.name }}</div>
      </div>
      <div class="line">
        <div class="title">准考证:</div>
        <div class="value">A0000001</div>
      </div>
      <div class="line">
        <div class="title">考场:</div>
        <div class="value">01</div>
      </div>
      <div class="line">
        <div class="title">座位号:</div>
        <div class="value">01</div>
      </div>
    </div>

    <ueditor_dialog
      v-if="ueditorDialogData.flag"
      :title="ueditorDialogData.title"
      :content="ueditorDialogData.content"
      @cancelDialog="cancelDialog"
      @makeSure="makeSure"
    ></ueditor_dialog>
  </div>
</template>

<script>
import * as questionData from "../../admin/question_bank/js/question.js";
import * as practiceData from "./js/practice.js";
export default {
  data() {
    return {
      examId: "",
      subject: [], // 科目,从上一个界面带过来
      flag: "",
      isDisable: false, // 是否禁用
      loading: false,

      timer: null,
      timeDiff: "考试已结束!",

      userData: {},

      data: practiceData.getinitExamData(),
      testName: "考试主题", // 考试主题
      allIndex: 0,
      tempItemIndex: 0,
      tempQuestion: {},
      indexType: 0,
      tempQuestionOptionIndex: 0,
      ueditorDialogData: {
        title: "",
        flag: false,
        content: "",
      },
    };
  },
  methods: {
    /**
     * 初始化考试试卷界面
     */
    async initData() {
      try {
        let requestData = {};
        let resultData = {};
        this.allIndex = 0;
        switch (this.flag) {
          case "0":
            // 开始考试
            console.log("开始考试");
            let subject = [];
            this.subject.forEach((element, index) => {
              let dd = {
                subjectId: element.value,
                proportion: "0",
              };
              subject.push(dd);
            });
            requestData = { examId: this.examId, subject: subject };
            resultData = await this.$request({
              url: "/imitateExam/startImitateExam",
              method: "post",
              data: requestData,
            });
            this.testName = resultData.name;
            this.examId = resultData.id;
            this.data = resultData.testPaper; // 试卷具体题目  返回数据中没有答案选项
            this.data.forEach((element) => {
              element.item.forEach((ele) => {
                let isAnswer = false;
                let answer = "";
                if (element.type == "4") {
                  // 简答
                  answer = { value: "", htmlValue: "" };
                } else if (element.type == "1") {
                  // 多选
                  answer = [];
                } else if (element.type == "2") {
                  //  填空
                  answer = [];
                  let ary = questionData.questionItemReset(ele.questionStem);
                  ary.forEach((element) => {
                    let dd = {
                      title: element.title,
                      value: "",
                      htmlValue: "",
                    };
                    answer.push(dd);
                  });
                } else {
                  answer = "";
                }
                this.$set(ele, "answer", answer);
                this.$set(ele, "isAnswer", isAnswer);
                this.allIndex++;
              });
            });
            this.chooseQuestion(this.data[0].item[0], 0, 0);
            this.intervalTime(
              this.calculateTime(resultData.time, resultData.examDuration)
            );
            break;

          default:
            // 查看考试详情
            requestData = { id: this.examId };
            resultData = await this.$request({
              url: "/imitateExam/showImitateExamDetails",
              method: "post",
              data: requestData,
            });
            this.data = resultData.testPaper; // 试卷具体题目  返回数据中没有答案选项
            this.testName = resultData.name;
            this.data.forEach((element) => {
              element.item.forEach((ele) => {
                let answer = JSON.parse(JSON.stringify(ele.answer));
                switch (element.type) {
                  case "0":
                  // 单选题
                  case "3":
                    // 判断题
                    ele.answer = answer.length > 0 ? answer[0].value : "";
                    break;
                  case "4":
                    // 简答题
                    ele.answer =
                      answer.length > 0
                        ? answer[0]
                        : { value: "", htmlValue: "" };
                    break;
                  case "1":
                    // 多选
                    ele.answer = [];
                    answer.forEach((e) => {
                      ele.answer.push(e.value);
                    });
                  case "2":
                    // 填空
                    break;

                  default:
                    break;
                }
                let isAnswer = false;
                if (element.type == "4") {
                  // 简答
                  if (ele.answer.value && ele.answer.value != "") {
                    isAnswer = true;
                  }
                } else if (element.type == "2") {
                  //   填空
                  if (ele.answer.length > 0 && ele.answer[0].value != "") {
                    isAnswer = true;
                  }
                } else if (element.type == "1") {
                  // 多选
                  if (ele.answer.length > 0 && ele.answer[0] != "") {
                    isAnswer = true;
                  }
                } else {
                  if (ele.answer != "") {
                    isAnswer = true;
                  }
                }
                this.$set(ele, "isAnswer", isAnswer);
                this.allIndex++;
              });
            });
            this.chooseQuestion(this.data[0].item[0], 0, 0);
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
        if (error.code == "10037") {
          sessionStorage.setItem("testing", "1");
          this.$router.back();
        }
      }
    },
    /**
     * 考试倒计时
     * examTime : 考试结束时间
     */
    intervalTime(endTime) {
      const examTime = new Date(endTime); // 考试开始时间
      const nowTime1 = new Date(); // 当前时间
      const timeDiff1 = Math.abs(nowTime1.getTime() - examTime.getTime());
      let that = this;
      // 考试时间就今天
      this.timer = setInterval(async () => {
        // console.log("定时器", endTime);
        let nowTime = new Date();
        let timeDiff = examTime.getTime() - nowTime.getTime();
        if (timeDiff <= 0) {
          // 强制交卷
          that.timeDiff = "考试已结束!";
          clearInterval(this.timer);
          await that.submitExam();
        } else {
          const hours = Math.floor(timeDiff / (1000 * 60 * 60));
          timeDiff -= hours * (1000 * 60 * 60);
          const minutes = Math.floor(timeDiff / (1000 * 60));
          timeDiff -= minutes * (1000 * 60);
          const seconds = Math.floor(timeDiff / 1000);
          that.timeDiff =
            `距离考试结束还剩 :` +
            `${hours} 小时 ${minutes} 分钟 ${seconds} 秒`;
        }
      }, 1000);
    },
    /**
     * 计算考试结束时间
     * time : 开考时间
     * minutes : 考试时长
     */
    calculateTime(time, minutes) {
      const date = new Date(time);
      const timestamp = date.getTime() + minutes * 60 * 1000;
      const newDate = new Date(timestamp);
      const year = newDate.getFullYear();
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const day = String(newDate.getDate()).padStart(2, "0");
      const hour = String(newDate.getHours()).padStart(2, "0");
      const minute = String(newDate.getMinutes()).padStart(2, "0");
      const second = String(newDate.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    /**
     * 小写数字转大写数字
     */
    transitionNumToText(num) {
      let text = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
      return text[num];
    },
    /**
     * 显示题型(文字)
     */
    transitionName(type) {
      return questionData.initTableValue("topic", type);
    },
    /**
     * 切换题目
     */
    chooseQuestion(question, indexType, itemIndex) {
      console.log("当前具体题目", question);
      this.tempQuestion = question;
      this.indexType = indexType;
      this.tempItemIndex = itemIndex;
      if (
        this.data[indexType].type == "2" &&
        this.tempQuestion.answer.length == 0
      ) {
        // 填空题  对题干做处理  判断当中有多少个空需要填写
        let answer = questionData.questionItemReset(
          this.tempQuestion.questionStem
        );
        console.log(answer);
        // this.tempQuestion.answer = [];
        // answer.forEach((element) => {
        //   let dd = {
        //     title: element.title,
        //     value: "",
        //     htmlValue: "",
        //   };
        //   this.tempQuestion.answer.push(dd);
        // });
        this.tempQuestion.isAnswer = false;
      }
      if (
        this.data[indexType].type == "4" &&
        this.tempQuestion.answer.value == null
      ) {
        // 简答题  对答案做处理
        this.tempQuestion.answer = { value: "", htmlValue: "" };
        this.tempQuestion.isAnswer = false;
      }
    },
    /**
     * 上一题下一题切换
     */
    chooseQuestionBut(flag) {
      try {
        let question = [];
        let indexType = -1;
        let tempItemIndex = 0;
        if (flag == 0) {
          // 上一题
          if (this.tempQuestion.index == "1") {
            // 已经是第一题,不可继续上一题操作
            throw "当前已是第一题!";
          }
          if (this.tempItemIndex == 0) {
            indexType = this.indexType - 1;
            tempItemIndex = this.data[indexType].item.length - 1;
          } else {
            indexType = this.indexType;
            tempItemIndex = this.tempItemIndex - 1;
          }
          question = this.data[indexType].item[tempItemIndex];
        } else {
          if (this.tempQuestion.index == this.allIndex) {
            // 已经是最后一题,不可继续下一题操作
            throw "当前已是最后一题!";
          }
          if (this.tempItemIndex == this.data[this.indexType].item.length - 1) {
            indexType = this.indexType + 1;
            tempItemIndex = 0;
          } else {
            indexType = this.indexType;
            tempItemIndex = this.tempItemIndex + 1;
          }
          question = this.data[indexType].item[tempItemIndex];
        }
        this.chooseQuestion(question, indexType, tempItemIndex);
      } catch (error) {
        this.$message({
          message: error,
          type: "warning",
          duration: 1000,
        });
      }
    },
    /**
     * 单选/多选  选择答案
     * 渲染界面是否显示以做
     */
    changeAnswer() {
      let isAnswer = false;
      if (this.data[this.indexType].type == "4") {
        // 简答
        if (
          this.tempQuestion.answer.value &&
          this.tempQuestion.answer.value != ""
        ) {
          isAnswer = true;
        }
      } else if (this.data[this.indexType].type == "2") {
        //  填空
        if (this.tempQuestion.answer.length > 0) {
          isAnswer = true;
        }
      } else {
        if (this.tempQuestion.answer != "") {
          isAnswer = true;
        }
      }
      this.tempQuestion.isAnswer = isAnswer;
    },
    /**
     * 编辑题干
     */
    editQuestionStem(title, content, index) {
      if (!this.isDisable) {
        this.tempQuestionOptionIndex = index;
        this.ueditorDialogData.title = title;
        this.ueditorDialogData.content = content;
        this.ueditorDialogData.flag = true;
      }
    },
    /**
     * 确认编辑框内容
     */
    makeSure(content) {
      console.log("编辑器返回的值", content);
      let data = questionData.questionItemReset(content.content);
      let text = questionData.questionItemReset(content.text);
      if (this.ueditorDialogData.title == "填空题答案") {
        // 编辑选项
        if (data.length > 0) {
          this.$message.error("答案中不可有填空");
          return;
        }
        if (this.tempQuestionOptionIndex >= 0) {
          // 找到对应的选项的值
          this.tempQuestion.answer[this.tempQuestionOptionIndex].htmlValue =
            content.content;
          this.tempQuestion.answer[this.tempQuestionOptionIndex].value =
            content.text;
        }
      } else if (this.ueditorDialogData.title == "简答题答案") {
        if (data.length > 0) {
          this.$message.error("答案中不可有填空");
          return;
        }
        this.tempQuestion.answer.value = content.text;
        this.tempQuestion.answer.htmlValue = content.content;
      }
      this.cancelDialog();
      this.changeAnswer();
    },
    /**
     * 关闭编辑框
     */
    cancelDialog() {
      this.ueditorDialogData.flag = false;
    },
    /**
     * 交卷
     */
    async submitExam() {
      try {
        console.log(this.data);
        let answerList = [];
        this.data.forEach((element) => {
          let dd = {};
          switch (element.type) {
            case "0":
            // 单选题
            case "3":
              // 判断题
              element.item.forEach((ele) => {
                dd = {
                  index: ele.index,
                  questionId: ele.questionId,
                  answer: [{ value: ele.answer, htmlValue: ele.answer }],
                };
                answerList.push(JSON.parse(JSON.stringify(dd)));
              });
              break;
            case "4":
              // 简答题
              element.item.forEach((ele) => {
                dd = {
                  index: ele.index,
                  questionId: ele.questionId,
                  answer: [ele.answer],
                };
                answerList.push(JSON.parse(JSON.stringify(dd)));
              });
              break;
            case "1":
              // 多选题
              element.item.forEach((ele) => {
                let ans = [];
                if (ele.answer.length > 0) {
                  ele.answer.forEach((e) => {
                    let d = {
                      value: e,
                      htmlValue: e,
                    };
                    ans.push(d);
                  });
                } else {
                  ans = [{ value: "", htmlValue: "" }];
                }
                dd = {
                  index: ele.index,
                  questionId: ele.questionId,
                  answer: ans,
                };
                answerList.push(JSON.parse(JSON.stringify(dd)));
              });
              break;
            case "2":
              // 填空题
              element.item.forEach((ele) => {
                dd = {
                  index: ele.index,
                  questionId: ele.questionId,
                  answer:
                    ele.answer.length > 0
                      ? ele.answer
                      : [{ value: "", htmlValue: "" }],
                };
                answerList.push(JSON.parse(JSON.stringify(dd)));
              });
              break;

            default:
              break;
          }
        });
        let requestData = {
          examId: this.examId,
          answerList: answerList,
        };
        let resultData = await this.$request({
          url: "/imitateExam/submitImitateExam",
          method: "post",
          data: requestData,
        });

        sessionStorage.setItem("testing", "1");
        this.$message.success("交卷成功!");
        // this.$router.back();
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 添加收藏
     */
    async changeCollect(flag) {
      try {
        let url =
          flag == 0
            ? "/errCollect/addErrCollect"
            : "/errCollect/removeErrCollectById";
        let requestData = {};
        let resultData = {};
        switch (flag) {
          case 0:
            // 添加收藏
            requestData = {
              questionId: this.tempQuestion.questionId,
              answer: this.tempQuestion.answer,
            };
            resultData = await this.$request({
              url: url,
              method: "post",
              data: requestData,
            });
            this.tempQuestion.isCollect = !this.tempQuestion.isCollect;
            this.tempQuestion.collectId = resultData.id;
            break;
          case 1:
            // 取消收藏
            requestData = {
              id: this.tempQuestion.collectId,
              flag: "collect",
            };
            resultData = await this.$request({
              url: url,
              method: "post",
              data: requestData,
            });
            this.tempQuestion.isCollect = !this.tempQuestion.isCollect;
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 关闭浏览器标签或直接刷新界面时,提交试卷
     */
    async handleUnload() {
      await this.submitExam();
    },
  },
  async mounted() {
    this.examId = this.$route.query.id;
    this.flag = this.$route.query.flag; // 0 为考试中,即答案可编辑
    this.subject = this.$route.query.subject; // 若当前为开始考试,从上一个界面获取本次模拟的科目列表
    console.log(this.subject);

    // 添加关闭浏览器标签或刷新界面事件
    window.addEventListener("beforeunload", this.handleUnload);

    this.userData = JSON.parse(sessionStorage.getItem("userData"));
    this.isDisable = this.flag != "0";
    sessionStorage.setItem("testing", this.flag);
    await this.initData();
    console.log(this.data, this.userData);
  },
  destoryed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  beforeDestroy() {
    // 在界面销毁时,移除该监听
    window.removeEventListener("beforeunload", this.handleUnload);
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
};
</script>

<style lang="less" scoped>
#index-exam-imitate-testing {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px 15px;
  box-sizing: border-box;
  > .left,
  > .right {
    width: 300px;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 10px;
    box-sizing: border-box;
    > .type {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;
      > .title {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 16px;
        font-weight: bold;
      }
      > .thumbnail {
        width: 100%;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        > .item {
          width: 50px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 15px;
          box-sizing: border-box;
          border: 1px solid #cecece;
          border-radius: 5px;
          margin-bottom: 6px;
          margin-right: 6px;
          cursor: pointer;
          position: relative;
          > i {
            position: absolute;
            bottom: 2px;
            right: 2px;
          }
        }
        > .is-answer {
          background-color: #3a93db;
          color: #fff;
        }
        > .is-active {
          background-color: #ff7f35;
          color: #fff;
        }
        .el-icon-circle-close {
          color: #aa2222;
        }
        .el-icon-circle-check {
          color: #17f33c;
        }
      }
    }
    > .icon {
      width: 100%;
      height: 240px;
      display: flex;
      align-items: center;
      justify-content: center;
      > img {
        width: 120px;
        height: 120px;
        // border-radius: 50px;
      }
    }
    > .line {
      width: 100%;
      height: 35px;
      display: flex;
      > .title {
        width: 35%;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 8px;
        font-size: 15px;
        font-weight: bold;
      }
      > .value {
        width: 0;
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        font-size: 15px;
      }
    }
  }
  > .centent {
    width: 0;
    flex: 1;
    height: 100%;
    margin: 0 15px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 10px;
    box-sizing: border-box;
    > .title {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 16px;
      font-weight: bold;
    }
    > .question-title {
      width: 100%;
      height: auto;
      line-height: 30px;
      display: flex;
      align-items: center;
      > .nd {
        margin-left: 10px;
        font-size: 14px;

        .el-icon-star-off {
          font-size: 15px;
          color: #e9e9e9;
        }
        .el-icon-star-on {
          color: #ffe710;
          font-size: 17px;
        }
      }
    }
    > .xx {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      padding: 0 20px;
      box-sizing: border-box;
      margin-top: 15px;
      .itel {
        width: 100%;
        height: auto;
        line-height: 30px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 5px;
        font-size: 15px;
        /deep/ .el-radio__label {
          display: flex;
        }
      }
    }
    > .da,
    > .da1 {
      width: 100%;
      height: auto;
      display: flex;
      padding: 0 20px;
      box-sizing: border-box;
      margin-top: 20px;
      > .ti {
        width: auto;
        height: 40px;
        margin-right: 8px;
        font-size: 15px;
        font-weight: bold;
        margin: 10px 0;
        display: flex;
        align-items: center;
      }
      > .tv {
        width: 0;
        flex: 1;
        height: auto;
        min-height: 40px;
        display: flex;
        align-items: center;
        margin-left: 10px;
      }
      > .pd {
        flex-direction: column;
        > .li {
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          margin: 10px 0;
          .li-va {
            width: 0;
            height: 100%;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 0 10px;
            box-sizing: border-box;
          }
        }
      }
    }
    > .da1 {
      margin-top: 0px;
    }
    > .buts {
      width: 100%;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 0 10px;
      box-sizing: border-box;
      > .but {
        width: auto;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 70px;
        box-sizing: border-box;
        margin: 0 15px;
        background-color: @baseColor;
        color: #fff;
        cursor: pointer;
      }
      > .start {
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          font-size: 23px;
          cursor: pointer;
        }
        .icon-shoucang1 {
          color: #ff7f35;
        }
      }
    }
  }
  .ueditor {
    border: 1px solid @baseColor;
    margin-left: 10px;
    cursor: pointer;
    padding: 5px;
    box-sizing: border-box;
  }

  /deep/ .gapfilling-span {
    /* background-color: antiquewhite; */
    display: inline-block;
    /* text-decoration: underline; */
    border-bottom: 1px solid #444;
    padding: 0 30px;
    margin: 0 5px;
  }
  .el-icon-star-off {
    font-size: 25px;
    color: #eeeeee;
    cursor: pointer;
  }
  .el-icon-star-on {
    color: #ffe710;
    font-size: 25px;
    cursor: pointer;
  }
  // .el-radio-button__inner,
  // .el-radio-group {
  //   display: flex;
  //   align-items: center;
  // }
  /deep/.el-checkbox__label {
    display: flex;
  }
  .answer {
    color: #356bff;
  }
}
</style>